import { render, staticRenderFns } from "./zhaoshangdanao.vue?vue&type=template&id=34bf0960&scoped=true&"
import script from "./zhaoshangdanao.vue?vue&type=script&lang=js&"
export * from "./zhaoshangdanao.vue?vue&type=script&lang=js&"
import style0 from "./zhaoshangdanao.vue?vue&type=style&index=0&id=34bf0960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf0960",
  null
  
)

export default component.exports